import { MapsAPILoader } from '@agm/core';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import MarkerClusterer from '@google/markerclustererplus';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ImageModalComponent } from '../../../components/modals/image-modal/image-modal.component';
import { MediaConfirmationDeleteComponent } from '../../../components/modals/media-confirmation-delete/media-confirmation-delete.component';
import { SeeAllCommentsComponent } from '../../../components/modals/see-all-comments/see-all-comments.component';
import { Denounce } from '../../../core/models/denounce.model';
import { ComplaintsService } from '../../../core/services/complaints.service';
import { UserService } from '../../../core/services/user.service';
import { UtilsService } from '../../../core/services/utils.service';
import { AppState } from '../../../core/state/app.reducer';
import * as fromComplaintsActions from '../../home/state/complaints.actions';
import { ModalHistoryStatusComponent } from '../modal-history-status/modal-history-status.component';
import { ModalStatusConfirmComponent } from '../modal-status-confirm/modal-status-confirm.component';
import { ReadMoreComponent } from '../read-more/read-more.component';

interface StatusRegister {
	status: {
		main: string;
		subs: { created_at: string; text: string }[];
		author: string;
	};
}

@Component({
	selector: 'app-ocorrence-details',
	templateUrl: './ocorrence-details.component.html',
	styleUrls: ['./ocorrence-details.component.scss'],
})
export class OcorrenceDetailsComponent implements OnInit {
	commentForm = this.formBuilder.group({
		body: '',
	});
	superUser;
	panelOpenState = false;
	public map: google.maps.Map;
	public markers = [];
	private denounceId: string;
	private denounce: any;
	private readMoreWrapper = false;
	private menuActions: boolean;
	public loading = true;
	public currentStatus = null;
	selectedValue = '';
	detailsOcurrence = {};
	commentMessage = '';
	emergency = false;
	private clickEventsubscription: Subscription;
	private notFound: boolean = null;
	private confirmedUser: boolean;

	loadingMedia = false;
	loadingNotes = false;

	notes = [];

	selectedStatus = [
		{
			main: 'Relato recebido',
			sub: 'SUB_STATUS_RECEIVED',
			name: 'Relato recebido pelo órgão responsável',
		},
		{
			main: 'Em análise',
			sub: 'SUB_STATUS_IMAGE_ANALYSIS',
			name: 'Órgão responsável identificando imagens',
		},
		{
			main: 'Em análise',
			sub: 'SUB_STATUS_IMAGE_FOUND',
			name: 'Imagens encontradas e sob análise',
		},
		{
			main: 'Em análise',
			sub: 'SUB_STATUS_IMAGE_NOT_FOUND',
			name: 'Não foi possivel encontrar imagens do caso',
		},
		{
			main: 'Análise concluída',
			sub: 'SUB_STATUS_IMAGE_FORWARDED',
			name: 'Relato concluído',
		},
		{
			main: 'Análise concluída',
			sub: 'SUB_STATUS_INCONCLUSIVE',
			name: 'Relato inconclusivo - poucas informações',
		},
	];

	center;

	historyStatus: any = [];

	statusHistory: StatusRegister[] = [];

	private placeDenounce: { onibus: any; parada: any; terminal: any };

	user = {
		gender: '',
		age: 0,
		race: '',
	};

	constructor(
		private store: Store<AppState>,
		private formBuilder: FormBuilder,
		private complaintsService: ComplaintsService,
		private userService: UserService,
		public mapsAPILoader: MapsAPILoader,
		private toastr: ToastrService,
		private route: ActivatedRoute,
		public dialog: MatDialog,
		public utils: UtilsService
	) {
		this.clickEventsubscription = this.utils.getClickEvent().subscribe(() => {
			this.menuActions = !this.menuActions;
		});
	}

	formatTimestamp(datetime: Date) {
		const timestamp = new Date(datetime);
		const day = ('0' + timestamp.getDate()).slice(-2);
		const month = ('0' + (timestamp.getMonth() + 1)).slice(-2);
		const year = timestamp.getFullYear().toString().slice(-2);
		const hours = ('0' + timestamp.getHours()).slice(-2);
		const minutes = ('0' + timestamp.getMinutes()).slice(-2);

		return `${day}/${month}/${year} - ${hours}:${minutes}`;
	}

	ngOnInit(): void {
		this.loading = true;
		this.superUser = Boolean(localStorage.getItem('superUser'));
		this.getDenounce(this.route.snapshot.paramMap.get('id'));
		this.placeDenounce = { terminal: false, parada: false, onibus: false };
		if (this.denounce && this.denounce.op_comments)
			this.denounce.op_comments = this.denounce.op_comments.reverse();
	}

	ngAfterContentChecked(): void {
		this.paintStatus(this.currentStatus);
	}

	public openImagerModal(target: any): void {
		this.dialog.open(ImageModalComponent, {
			panelClass: 'image-modal',
			height: '50%',
			width: '50%',
			data: {
				denounce: this.denounce,
				image: target,
			},
		});
	}

	public openDeleteMediaModal(target: any): void {
		this.dialog.open(MediaConfirmationDeleteComponent, {
			panelClass: 'media-modal',
			height: '40%',
			width: '40%',
			data: {
				media: target,
			},
		});
	}

	public deleteMediaFunc(data: string): void {
		const dialog = this.dialog.open(MediaConfirmationDeleteComponent, {
			panelClass: 'media-modal',
			width: '40%',
		});

		dialog.afterClosed().subscribe((response) => {
			if (response === true) {
				this.deleteMedia(data);
				this.hideImageButton();
			}
		});
	}

	selectedFiles: any[] = [];

	public onFileSelected(event: any): void {
		this.selectedFiles.push(event.target.files);

		const image = event.target.files[0];

		const previews = document.querySelector('.selected-files-preview');

		const imgDiv = document.createElement('div');
		imgDiv.style.display = 'flex';
		imgDiv.style.alignItems = 'center';
		imgDiv.style.marginBottom = '.5rem';
		imgDiv.style.position = 'relative';

		const isVideo = image.type.startsWith('video/');

		const img = document.createElement('img');
		const video = document.createElement('video');
		if (isVideo) {
			video.src = URL.createObjectURL(image);
			video.controls = false;
			video.style.width = '4rem';
			video.style.height = '4rem';
			video.style.marginRight = '1rem';
			video.style.objectFit = 'cover';
			video.style.borderRadius = '16px';

			previews?.appendChild(imgDiv);
			imgDiv.appendChild(video);
		} else {
			img.src = URL.createObjectURL(image);

			previews?.appendChild(imgDiv);
			imgDiv.appendChild(img);

			img.style.width = '4rem';
			img.style.height = '4rem';
			img.style.marginRight = '1rem';
			img.style.objectFit = 'cover';
			img.style.borderRadius = '16px';
		}

		const button = document.createElement('button');

		button.style.backgroundColor = '#5B43D9';
		button.style.border = 'none';
		button.style.borderRadius = '50%';
		button.style.width = '1.5rem';
		button.style.height = '1.5rem';
		button.style.display = 'flex';
		button.style.justifyContent = 'center';
		button.style.alignItems = 'center';
		button.style.cursor = 'pointer';
		button.style.position = 'absolute';
		button.style.top = '-.3rem';
		button.style.right = '.3rem';

		const buttonIcon = document.createElement('img');
		buttonIcon.src = 'assets/icons/trash.svg';
		buttonIcon.style.width = '1rem';
		buttonIcon.style.height = '1rem';
		button.appendChild(buttonIcon);

		imgDiv.appendChild(button);

		button.addEventListener('click', () => {
			imgDiv?.removeChild(isVideo ? video : img);
			imgDiv?.removeChild(button);

			const index = this.selectedFiles.indexOf(image);
			if (index > -1) {
				this.selectedFiles.splice(index, 1);
			}
		});
	}

	openSeeComments(): void {
		if (this.denounce.op_comments) {
			this.denounce.op_comments = this.denounce.op_comments.reverse();
		}
		this.dialog.open(SeeAllCommentsComponent, {
			panelClass: 'read-modal',
			height: '800px',
			width: '600px',
			maxHeight: '65vh',
			data: {
				denounce: this.denounce,
			},
		});
	}

	openReadMore(): void {
		this.dialog.open(ReadMoreComponent, {
			panelClass: 'read-modal',
			height: 'auto',
			width: '600px',
			data: {
				denounce: this.denounce,
			},
		});
	}

	openModalConfirmStatus(): void {
		this.dialog.open(ModalStatusConfirmComponent, {
			panelClass: 'read-modal',
			height: 'auto',
			width: '600px',
			data: {
				denounce: this.denounce,
				selectedValue: this.selectedValue,
				denounceId: this.denounceId,
			},
		});

		this.dialog.afterAllClosed.subscribe(() => {
			this.getDenounce(this.denounceId);
		});
	}

	openModalHistoryStatus(): void {
		this.dialog.open(ModalHistoryStatusComponent, {
			panelClass: 'read-modal',
			height: 'auto',
			width: '700px',
			data: {
				denounce: this.denounce,
			},
		});
	}

	putStatusDenounce(): void {
		this.openModalConfirmStatus();
		/*
		this.complaintsService.putStatusDenounce(this.selectedValue, this.denounceId).subscribe((response) => {
			this.toastr.success('Status alterado com sucesso.');
			this.getDenounce(this.denounceId);
		});
		/*/
	}

	selectValueChange(event: any): void {
		this.selectedValue = event.target.value;
	}

	convertDateFormat(inputDate: string) {
		const date = new Date(inputDate);

		date.setHours(date.getHours() - 3);

		const day = String(date.getDate()).padStart(2, '0');
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const year = String(date.getFullYear()).slice(-2);

		const formattedDate = `${day}/${month}/${year}`;

		const hour = String(date.getHours()).padStart(2, '0');
		const minute = String(date.getMinutes()).padStart(2, '0');

		const formattedTime = `${hour}:${minute}`;

		return `${formattedDate} - ${formattedTime}`;
	}

	groupStatusHistory(statusHistory: any): StatusRegister[] {
		const groupedStatusHistory: StatusRegister[] = [];
		const groupedMains = []; // register already grouped main statuses

		for (let i = 0; i < statusHistory.length; i++) {
			const status = statusHistory[i];

			if (groupedMains.includes(status.status.main)) {
				// find the element whose main is the same

				const index = groupedStatusHistory.findIndex(
					(element) => element.status.main === status.status.main
				);

				if (index !== -1) {
					groupedStatusHistory[index].status.subs.push({
						created_at: status.created_at,
						text: status.status.sub,
					});
				}
			} else {
				groupedMains.push(status.status.main);

				groupedStatusHistory.push({
					status: {
						main: status.status.main,
						subs: [
							{
								created_at: status.created_at,
								text: status.status.sub,
							},
						],
						author: status.author,
					},
				});
			}
		}

		return groupedStatusHistory;
	}

	userName: string = '';
	userCPF: string = '';

	opMediasCount: number = 0;

	isFestival: boolean = false;

	translateType(type: string): string {
		return this.utils.translateType(type);
	}

	getDenounce(id: string): void {
		this.denounceId = id;
		this.complaintsService.getDenounce(id).subscribe((denounce: any) => {
			if (denounce.place === 'BUS') {
				this.placeDenounce.onibus = true;
			}
			if (denounce.place === 'BUS_STOP') {
				this.placeDenounce.parada = true;
			}
			if (denounce.place === 'BUS_TERMINUS') {
				this.placeDenounce.terminal = true;
			}

			if (denounce.user_data?.name) {
				this.userName = denounce.user_data.name;
			}

			if (denounce.user_data?.['custom:cpf']) {
				this.userCPF = denounce.user_data['custom:cpf'];
			}

			this.emergency = denounce.at_moment;

			this.currentStatus = this.mapStatusToNumber(denounce.current_status.main);
			this.denounce = denounce;
			this.setMap(denounce.address_coordinates);

			this.statusHistory = this.groupStatusHistory(denounce.status_history);

			let medias = [];
			if (denounce.op_media) {
				const previews = document.querySelector('.files-preview');
				if (previews) previews.innerHTML = '';
				this.opMediasCount = 0;

				const drawImages = async () => {
					for (const media of denounce.op_media) {
						this.opMediasCount++;
						const isVideo = media.endsWith('.mp4');

						try {
							const url = await this.complaintsService
								.fetchMediaUrl(media, 'op')
								.toPromise();
							await this.drawImagePreview(url, isVideo);
						} catch (error) {
							console.error(error);
						}
					}
				};

				drawImages();
			}
			if (denounce.media) {
				denounce.media.forEach((media) => {
					medias.push(media);

					const mediaName = media.split('/').pop();

					this.complaintsService
						.fetchMediaUrl(mediaName, 'user')
						.subscribe((url) => {
							checkMediaType(url).then((isVideo) => {
								this.drawImagePreview(url, isVideo, true);
							});
						});
				});
			}
			this.denounce.media = medias;
			let date = new Date(this.denounce.datetime);
			date.setHours(date.getHours() - 3);
			this.denounce.datetime = date;
			//aqui
			date = new Date(this.denounce.created_at);
			date.setHours(date.getHours() - 3);
			this.denounce.created_at = date;

			date = new Date(this.denounce.modified_at);
			date.setHours(date.getHours() - 3);
			this.denounce.modified_at = date;

			this.getUser(denounce.user_id);
			if (this.denounce && this.denounce.op_comments) {
				this.notes = this.denounce.op_comments;
			}

			this.detailsOcurrence = {
				gender: this.denounce.victim_details.gender,
				age: this.denounce.victim_details.age_group,
				sexuality: this.denounce.victim_details.sexuality,
				race: this.denounce.victim_details.ethnicity,
			};
		});
	}

	updateCommentMessage(value: string) {
		this.commentMessage = value;
	}

	sendComment() {
		this.loadingNotes = true;

		if (this.selectedFiles.length > 0) {
			for (let i = 0; i < this.selectedFiles.length; i++) {
				const previews = document.querySelector('.selected-files-preview');
				if (previews) previews.innerHTML = '';

				this.addMedia(this.selectedFiles[i]);
			}

			this.selectedFiles = [];

			if (this.commentMessage === '') {
				this.loadingNotes = false;

				return;
			}
		}

		if (this.commentMessage === '') {
			this.toastr.error('O comentário não pode estar vazio.');
			return;
		}

		const message = this.commentMessage;
		this.commentMessage = '';

		this.complaintsService
			.commentComplaint(this.denounceId, message)
			.subscribe((response) => {
				this.toastr.success('Comentário adicionado com sucesso.');

				this.getDenounce(this.denounceId);
				this.loadingNotes = false;
			});
	}

	public paintStatus(statusID: number): any {
		for (let i = 0; i <= statusID; i++) {
			let status = document.querySelector(`#status-${i}`);
			status?.querySelector('.ellipse')?.classList.add('active-line');
			status?.querySelector('.line')?.classList.add('active-background-line');
			if (i == 2)
				status
					?.querySelector('.ellipse-conclusion')
					?.classList.add('active-line');
			status = document.querySelector(`#status-${statusID}`);
			status
				?.querySelector('.line')
				?.classList.remove('active-background-line');
		}
	}

	drawImagePreview = (
		url: string,
		isVideo: boolean,
		isUser: boolean = false
	) => {
		const previews = document.querySelector(
			isUser ? '.user-files-preview' : '.files-preview'
		);

		const imgDiv = document.createElement('div');
		imgDiv.style.display = 'flex';
		imgDiv.style.alignItems = 'center';
		imgDiv.style.marginBottom = '.5rem';
		imgDiv.style.position = 'relative';

		const img = document.createElement('img');
		const video = document.createElement('video');

		if (isVideo) {
			video.src = url;
			video.controls = false;
			video.style.width = '4rem';
			video.style.height = '4rem';
			video.style.marginRight = '1rem';
			video.style.objectFit = 'cover';
			video.style.borderRadius = '16px';
			video.style.cursor = 'pointer';

			video.onclick = () => {
				this.openImage(url, true);
			};

			previews?.appendChild(imgDiv);
			imgDiv.appendChild(video);
		} else {
			img.src = url;

			img.onclick = () => {
				this.openImage(url, false);
			};

			previews?.appendChild(imgDiv);
			imgDiv.appendChild(img);

			img.style.width = '4rem';
			img.style.height = '4rem';
			img.style.marginRight = '1rem';
			img.style.objectFit = 'cover';
			img.style.borderRadius = '16px';
			img.style.cursor = 'pointer';
		}
	};

	public addMedia(files: FileList): void {
		this.loadingMedia = true;
		let file: File | null = null;
		file = files.item(0);
		const image = files[0];

		const formData = new FormData();

		this.complaintsService
			.addMedia(this.denounceId, file.name)
			.subscribe(async (response: any) => {
				const url = response.url;

				formData.append(
					'x-amz-meta-complaint-id',
					response.fields['x-amz-meta-complaint-id']
				);
				formData.append('Content-Type', response.fields['Content-Type']);
				formData.append('key', response.fields.key);
				formData.append('AWSAccessKeyId', response.fields.AWSAccessKeyId);
				formData.append(
					'x-amz-security-token',
					response.fields['x-amz-security-token']
				);
				formData.append('policy', response.fields.policy);
				formData.append('signature', response.fields.signature);

				formData.append('file', file);

				const req = new Request(url, {
					method: 'POST',
					headers: {},
					body: formData,
				});

				fetch(req)
					.then((response) => response.text())
					.then((res) => {
						if (res) {
						} else {
							this.toastr.success('Imagem adicionada com sucesso.');

							// this.opMediasCount++;

							this.loadingMedia = false;

							// const previews = document.querySelector('.files-preview');

							// const imgDiv = document.createElement('div');
							// imgDiv.style.display = 'flex';
							// imgDiv.style.alignItems = 'center';
							// imgDiv.style.marginBottom = '.5rem';
							// imgDiv.style.position = 'relative';

							// const isVideo = file.type.startsWith('video/');

							// const img = document.createElement('img');
							// const video = document.createElement('video');
							// if (isVideo) {
							// 	video.src = URL.createObjectURL(image);
							// 	video.controls = false;
							// 	video.style.width = '4rem';
							// 	video.style.height = '4rem';
							// 	video.style.marginRight = '1rem';
							// 	video.style.objectFit = 'cover';
							// 	video.style.borderRadius = '16px';

							// 	previews?.appendChild(imgDiv);
							// 	imgDiv.appendChild(video);
							// } else {
							// 	img.src = URL.createObjectURL(image);

							// 	previews?.appendChild(imgDiv);
							// 	imgDiv.appendChild(img);

							// 	img.style.width = '4rem';
							// 	img.style.height = '4rem';
							// 	img.style.marginRight = '1rem';
							// 	img.style.objectFit = 'cover';
							// 	img.style.borderRadius = '16px';
							// }

							// setTimeout(() => {
							this.getDenounce(this.denounceId);
							// }, 500);
						}
					});
			});
	}

	getUser(id: string): void {
		this.userService.getUser(id).subscribe(
			(user) => {
				if (user.status !== 400) {
					this.user.gender = user.gender;
					const today = new Date();
					const birth = new Date(user.birthdate);
					const race = user['custom:race'];
					this.user.race = race;
					birth.setHours(birth.getHours() + 3);
					this.user.age = today.getFullYear() - birth.getFullYear();
					if (user === 404) {
						this.confirmedUser = false;
						this.loading = false;
					} else {
						this.confirmedUser = true;
						this.loading = false;
					}
				}
			},
			(_) => {
				this.notFound = true;
				this.user.age = 0;
				this.user.gender = '--';
				this.loading = false;
			}
		);
	}

	seeMore(): void {
		this.readMoreWrapper = !this.readMoreWrapper;
	}
	private updateComplaintOnStore(): void {
		this.store.dispatch(fromComplaintsActions.loadComplaints());
	}

	public addComment(body_comment: string): void {
		this.complaintsService
			.commentComplaint(this.denounceId, body_comment)
			.subscribe(async (response: any) => {
				this.getDenounceUpdateComments(this.denounceId);
				this.updateComplaintOnStore();
				this.toastr.success('Comentário adicionado com sucesso.');
				this.denounce.op_comments = this.denounce.op_comments.reverse();
			});
	}

	onSubmitComment(): void {
		if (this.commentForm.value.body) {
			this.addComment(this.commentForm.value.body);
			this.commentForm.reset();
		}
	}

	getDenounceUpdateComments(id: string): void {
		this.complaintsService
			.getDenounce(this.denounce._id)
			.subscribe((denounce: Denounce) => {
				this.denounce.op_comments = denounce?.op_comments;
				this.denounce = denounce;
			});
	}

	public setMap(coordenadas): void {
		if (coordenadas) {
			this.center = {
				lat: coordenadas.coordinates[0],
				lng: coordenadas.coordinates[1],
			};

			this.markers = [
				{
					lat: coordenadas.coordinates[0],
					lng: coordenadas.coordinates[1],
				},
			];

			if (document.getElementById('map')) {
				this.mapsAPILoader.load().then(() => {
					this.map = new google.maps.Map(
						document.getElementById('map') as HTMLElement,
						{
							zoom: 13,
							center: this.center,
							disableDefaultUI: true, // Disable map controls
						}
					);

					setTimeout(() => {
						const markers = this.markers.map((marker) => {
							return new google.maps.Marker({
								position: { lat: marker.lat, lng: marker.lng },
								map: this.map,
								title: 'Custom Marker Title',
								icon: '../../../../assets/images/pin.png',
							});
						});

						new MarkerClusterer(this.map, markers, {
							imagePath:
								'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
						});
					});
				});

				setTimeout(() => {
					this.loading = false;
				});
			}
		}
	}

	public deleteMedia(media: string): void {
		const target = media.split('/').pop().split('?')[0];
		let op_media = false;
		if (this.denounce.op_media) {
			this.denounce.op_media.forEach((element) => {
				if (element.includes(target)) {
					op_media = true;
				}
			});
		}
		if (op_media) {
			let tgt = this.denounce.op_media.filter(
				(f: string) => f.indexOf(target) !== -1
			);
			if (tgt) {
				this.complaintsService
					.deleteOpMedia(tgt[0], this.denounceId)
					.subscribe((r) => {
						this.toastr.success('Imagem removida com sucesso.');
						this.isContentVisible = false;
					});
			}
		} else {
			let tgt = this.denounce.media.filter(
				(f: string) => f.indexOf(target) !== -1
			);
			if (tgt) {
				this.complaintsService
					.deleteUserMedia(tgt[0].split('/')[3], this.denounceId)
					.subscribe((r) => {
						this.toastr.success('Imagem removida com sucesso.');
					});
			}
		}

		this.getDenounce(this.denounceId);
	}

	get hideItems(): boolean {
		return this.denounce.description?.length === undefined;
	}

	formatarData(data: Date): string {
		data = new Date(data);
		if (data) {
			const dia = String(data.getDate()).padStart(2, '0');
			const mes = String(data.getMonth() + 1).padStart(2, '0'); // Os meses são base 0, então adicionamos 1
			const ano = String(data.getFullYear()).substr(2, 2);
			const hora = String(data.getHours()).padStart(2, '0');
			const minutos = String(data.getMinutes()).padStart(2, '0');

			return `${dia}/${mes}/${ano} - ${hora}:${minutos}`;
		}
	}

	translatePlace(location: string) {
		return this.utils.translatePlace(location);
	}

	mapStatusToNumber(status) {
		if (status === 'Relato registrado') {
			return 0; // Etapa de inicialização
		} else if (status === 'Em análise') {
			return 1; // Etapa de análise de imagem
		} else {
			return 2; // Etapa de relato inconclusivo
		}
	}

	ordenarAgruparStatus(statusHistory: any): any {
		if (statusHistory.length == 1) return statusHistory;
		statusHistory.sort(
			(a, b) =>
				new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
		);

		return statusHistory;
	}

	encontrarStatusMaisProximo(mainStatus: string): any {
		const filteredStatuses = this.historyStatus
			? this.historyStatus.filter((status) => status.status.main === mainStatus)
			: [];

		if (filteredStatuses.length === 0) {
			return null;
		}

		filteredStatuses.sort(
			(a, b) =>
				new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
		);

		return filteredStatuses[0];
	}

	isContentVisible: boolean = false;
	isContentVideo: boolean = false;
	imageSrc: string = '';

	openImage(image: string, isVideo) {
		this.isContentVideo = isVideo;
		this.isContentVisible = true;
		this.imageSrc = image;
	}

	hideImage(event?: MouseEvent) {
		const target = event.target as HTMLElement;
		if (
			event &&
			target.tagName !== 'BUTTON' &&
			target.tagName !== 'IMG' &&
			!target.closest('button')
		) {
			this.isContentVisible = false;
		}
	}

	hideImageButton() {
		this.isContentVisible = false;
	}

	downloadContent() {
		window.open(this.imageSrc, '_blank');
	}
}

const checkMediaType = (url: string): Promise<boolean> => {
	return new Promise((resolve) => {
		const img = new Image();
		img.onload = () => resolve(false);
		img.onerror = () => resolve(true);
		img.src = url;
	});
};
